/* ja-paragraphs.js
 * 商品説明などに含まれる連続した <br> （空行）を、
 * 高さをCSSで指定できるスペーサー <span class="ja-gap"> に置き換える。
 *
 * 背景: Shopifyの商品説明は段落を <p> ではなく <br><br> で作っているため、
 * 空行の高さ（= 行送り1行分）をCSSだけでは調整できない。
 * テキストやタグは一切削除せず、改行の役割だけを入れ替える。
 * theme.liquid の読み込み行を外せば元の表示に戻る。
 */
(function () {
  var SELECTOR = '.product__description, .accordion__content';

  function tighten(scope) {
    var brs = scope.querySelectorAll('br');
    var parents = [];
    for (var i = 0; i < brs.length; i++) {
      if (parents.indexOf(brs[i].parentNode) === -1) parents.push(brs[i].parentNode);
    }

    parents.forEach(function (parent) {
      var kids = Array.prototype.slice.call(parent.childNodes);
      var run = [];

      function flush() {
        // <br> が2つ以上続いているときだけ、
        // 1つ目は改行として残し、2つ目以降をスペーサー1つにまとめる
        if (run.length >= 2) {
          var gap = document.createElement('span');
          gap.className = 'ja-gap';
          parent.replaceChild(gap, run[1]);
          for (var i = 2; i < run.length; i++) {
            if (run[i].parentNode) run[i].parentNode.removeChild(run[i]);
          }
        }
        run = [];
      }

      kids.forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'BR') {
          run.push(node);
        } else if (node.nodeType === 3 && !node.textContent.trim()) {
          // タグ間の改行・インデントは無視して連続とみなす
        } else {
          flush();
        }
      });
      flush();
    });
  }

  function run() {
    var targets = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (el.getAttribute('data-ja-paragraphs')) continue;
      el.setAttribute('data-ja-paragraphs', '1');
      try {
        tighten(el);
      } catch (e) {
        // 失敗しても元の表示のままにする
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // テーマエディタでのセクション再描画に追従
  document.addEventListener('shopify:section:load', run);
})();
